import { useState } from 'react';
import { useOrgConversations } from '../../../hooks/useOrgConversations';
import { ConvList } from '../conv/ConvList';
import { ConvPane } from '../conv/ConvPane';

export function ConversationsTab({ orgId }: { orgId: string }) {
  const [activeId, setActiveId] = useState<string | null>(null);
  const { data: conversations, isLoading } = useOrgConversations(orgId);

  return (
    <div className="flex-1 flex min-h-0 border border-surface-200 rounded-lg overflow-hidden bg-surface-0">
      <ConvList
        conversations={conversations ?? []}
        activeId={activeId}
        onSelect={setActiveId}
        loading={isLoading}
      />
      {activeId ? (
        <ConvPane orgId={orgId} conversationId={activeId} />
      ) : (
        <div className="flex-1 flex items-center justify-center text-sm text-surface-500">
          Select a conversation to open.
        </div>
      )}
    </div>
  );
}
